module.exports = __webpack_public_path__ + "assets/media/marketo-import-icon.04c59d6a.svg";